<template>
  <div class="row">
    <div class="col-md-9">
      <div class="root">
        <a-card class="chat-box" hoverable>
          <a-card-meta :title="info.subject">
            <b-avatar
              size="2rem"
              slot="avatar"
              :src="$root.image_concat(info.user.image)"
            ></b-avatar>
          </a-card-meta>
          <div class="box" style="overflow-y: scroll; height: 60vh">
            <div
              class="container"
              :class="{
                dark: msg.user.type != 'admin',
                darker: msg.user.type == 'admin',
              }"
              v-for="msg in info.messages"
            >
              <p>{{ msg.message }}</p>
              <span
                :class="{
                  'time-right': msg.user.type != 'admin',
                  'time-left': msg.user.type == 'admin',
                }"
              >
                {{ new Date(msg.created_at).toTimeString().slice(0, 5) }}</span
              >
            </div>
          </div>

          <div
            v-if="info.status != 'closed'"
            class="row"
            style="
              position: absolute;
              bottom: 0;
              width: 100%;
              background-color: rgb(254 251 251 / 49%);
            "
          >
            <form
              @submit.prevent="reply($event)"
              v-show="$root.hasPermission('/tickets/reply/')"
            >
              <div class="row">
                <div class="col-md-10">
                  <textarea
                    v-model="msg"
                    style="margin-bottom: 10px"
                    class="form-control"
                    name="message"
                    id=""
                    cols="30"
                    rows="2"
                  ></textarea>
                </div>
                <div class="col-md-1">
                  <b-button type="submit" class="w-100" variant="outline-info"  :disabled="isLoading"
                    >ثبت</b-button
                  >
                </div>
              </div>
            </form>
          </div>
        </a-card>
      </div>
    </div>
    <div class="col-md-3">
      <a-card hoverable style="width: 100%; height: 80vh">
        <a-card-meta
          :title="
            info.user ? info.user.firstname + ' ' + info.user.lastname : ''
          "
          :description="new Date(info.created_at).toLocaleDateString('fa-IR')"
        >
          <b-avatar
            slot="avatar"
            size="2rem"
            :src="$root.image_concat(info.user.image)"
          ></b-avatar>
        </a-card-meta>
        <hr />
        <p>موضوع تيكت :{{ info.subject }}</p>
        <hr />
        <p>
          وضعیت تيكت :
          <b-badge
            pill
            v-if="info.status == 'closed'"
            variant="info"
            class="bg-success"
          >
            {{ info.status }}
          </b-badge>
          <b-badge
            pill
            v-else-if="info.status == 'waiting'"
            variant="warning"
            class="bg-warning"
          >
            {{ info.status }}
          </b-badge>
          <b-badge pill v-else variant="danger" class="bg-danger">
            {{ info.status }}
          </b-badge>
        </p>

        <hr />
        <form
          @submit.prevent="addData($event)"
          v-show="$root.hasPermission('/tickets/status/')"
        >
          <div class="row p-md-1">
            <div class="col-md-9 my-1">
              <label class="sr-only" for="inline-form-input-name">
                تغيير وضعيت تیکت</label
              >
              <select name="status" v-model="info.status" class="form-control">
                <option value="">انتخاب</option>
                <option value="waiting">در انتظار پاسخ</option>
                <option value="closed">تیکت بسته</option>
                <option value="open">تیکت باز</option>
              </select>
            </div>
            <div class="col-md-2 my-1">
              <label class="sr-only" for="inline-form-input-name"> </label>
              <b-button type="submit" variant="outline-success">ثبت</b-button>
            </div>
          </div>
        </form>
      </a-card>
    </div>
  </div>
</template>

<style>
.root {
  margin: 0 auto;
  max-width: 100%;
}

.chat-box {
  padding: 10px;
  height: 80vh;
}

.dark {
  border-radius: 0px 10px 10px 10px;
}

.container {
  border: 2px solid #000;
  background-color: #000;
  /* border-radius: 5px; */
  padding: 10px;
  margin-left: 0;
  width: 50% !important;
  margin-top: 1%;
  color: #fff;
}

.darker {
  border-color: #1890ff;
  background-color: #1890ff;
  margin-right: 0;
  border-radius: 10px 10px 0px 10px;
  color: white;
}

.container::after {
  content: "";
  clear: both;
  display: table;
}

.container img {
  float: left;
  max-width: 60px;
  width: 100%;
  margin-right: 20px;
  border-radius: 50%;
}

.container img.right {
  float: right;
  margin-left: 20px;
  margin-right: 0;
}

.time-right {
  float: right;
  color: #aaa;
}

.time-left {
  float: left;
  color: #f9e6e6;
}
</style>

<script>
export default {
  data() {
    return {
      info: {},
      msg: "",
      isLoading:false
    };
  },
  methods: {
    async getData() {
      let _this = this;
      await axios
        .get("/tickets/single/" + this.$route.params.id)
        .then(function (response) {
            
          _this.info = response.data;
        })
        .catch(function (err) {
          _this.$root.handleAxiosError(err);
        });
    },
    async addData(event) {
      let _this = this;
      let data = new FormData(event.target);
     if(this.isLoading != true){ 
      _this.$root.loading = true;
      let url = `/tickets/status/${this.info.id}`;
      await axios
        .post(url, data)
        .then(function (response) {
          _this.$root.loading = false;
          _this.$toast.success("تیکت با موفقیت ویرایش شد");
        })
        .catch(function (err) {
          _this.$root.loading = false;
          _this.$root.handleAxiosError(err);
        });}
    },
    async reply(event) {
      let _this = this;
      let data = new FormData(event.target);
      this.$root.loading = true;
      this.isLoading=true;
      let url = `/tickets/reply/${this.info.id}`;
 await axios
        .post(url, data)
        .then(function (response) {
          _this.$root.loading = false;
          _this.msg = "",
          _this.getData();
          _this.$toast.success("پیام شما با موفقیت ارسال شد.");
          _this.isLoading=false;

        })
        .catch(function (err) {
          _this.$root.loading = false;
          _this.isLoading=false;
          _this.$root.handleAxiosError(err);
        });
      
     
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
